import { generalHelpers } from '@/helpers';
import React from 'react';

interface Column {
  field: string;
  headerName: string;
  className?: string;
  isCheckbox?: boolean;
  isSort?: boolean;
  renderCell?: (row?: object) => React.ReactNode /*keyof JSX.IntrinsicElements*/;
}

export const column: Array<Column> = [
  {
    field: 'business_name',
    headerName: 'Business Name',
  },
  {
    field: 'country',
    headerName: 'Country',
  },

  {
    field: 'created_at',
    headerName: 'Date and time',
    renderCell: (row: any) => <p>{generalHelpers.formateTimeStampDate(row.created_at)}</p>,
  },
];
